/**
 * Protective method to ensure that a value is not undefined.
 * This is used in scenarios where we expect xapi to always return a valid value but are not 100% sure it will
 * Only use this if you think there is a possibility the value won't be defined but aren't sure.
 * If you know it can be undefined, update the types accordingly and use conditionals instead of this function
 * @template T
 * @param {T | undefined} val
 * @param {T} defaultVal
 * @returns {T}
 */
export default function safeType(val, defaultVal) {
  if (val === undefined) {
    console.warn('An xapi value is undefined that is expected to always be defined. See below trace.') // eslint-disable-line
    console.trace() // eslint-disable-line
    return defaultVal;
  }
  return val;
}
